
import axios from "axios"
import {ACCESS_TOKEN, KEY_MACHINEID, KEY_USER_INFO, SYS_CONFIG_DEV_MODE} from "@/Const";
import {notification} from "antd";
import Global from "@/global";
import {getCookies, isDevMode, isStringNullOrEmpty} from "@/utils";
import {APP_WEB, APP_WEB_SITE, APP_WEB_WWW, DEBUG, isWeb} from "@/electron_interactive";
import {useCookie} from "react-use";

// import cookie from 'react-cookies'
let mapErrCallback:any = {};

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: isDevMode()?import.meta.env.VITE_DEV_HTTP_BASE_URL:import.meta.env.VITE_HTTP_BASE_URL,
  timeout: 60000 // 请求超时时间,
})


export default request

export {
  request as axios,
    postRequest,
    getRequest,
    putRequest,
    switchBaseURL
}

const switchBaseURL =()=>{
  axios.defaults.baseURL = isDevMode()?import.meta.env.VITE_DEV_HTTP_BASE_URL:import.meta.env.VITE_HTTP_BASE_URL;
}

const postRequest = ({url,data,callback})=>{
  mapErrCallback[url] = callback;
  return request({
    url:url,
    data:data,
    method:'post'
  })
}

const getRequest = ({url,data,callback})=>{
  mapErrCallback[url] = callback;
  return request({
    url:url,
    data:data,
    method:'get'
  })
}

const putRequest = ({url,data,callback})=>{
  mapErrCallback[url] = callback;
  return request({
    url:url,
    data:data,
    method:'put'
  })
}


// 异常拦截处理器
const errorHandler = (error:any) => {
  if (error.response) {
    const data = error.response.data

    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data
      })
    }

    if (error.response.status === 404) {
      if(mapErrCallback[error.response.config.url]){
        mapErrCallback[error.response.config.url](error);
      }
    }

    if (error.response.status === 401) {
      localStorage.removeItem(ACCESS_TOKEN);
      localStorage.removeItem(KEY_USER_INFO);
      Global.g_userInfo = undefined;

      notification.error({
        message: data
      })
      if(mapErrCallback[error.response.config.url]){
        mapErrCallback[error.response.config.url]();
      }
      // 从 localstorage 获取 token
      // const token = localStorage.getItem(ACCESS_TOKEN)
      // if (token) {
      //   store.dispatch('Logout').then(() => {
      //     setTimeout(() => {
      //       window.location.reload()
      //     }, 1500)
      //   })
      // }
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  let token = localStorage.getItem(ACCESS_TOKEN)
  if (APP_WEB_WWW && isStringNullOrEmpty(token)){
    token = getCookies()['token'];
  }
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  config.headers["X-Device-Fingerprint"]= "000000";
  if (!isWeb()){
    config.headers["device-id"]= localStorage.getItem(KEY_MACHINEID)||'';
    // if (DEBUG) {
    //   config.headers["device-id"] = '7516d927-e30c-513e-8e1b-67cec1cb97a2';
    // }
  }

  if (token) {
    config.headers['Authorization'] = 'Bearer '+token
  }
  config.baseURL = isDevMode()?import.meta.env.VITE_DEV_HTTP_BASE_URL:import.meta.env.VITE_HTTP_BASE_URL;
  return config;
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  return response.data
}, errorHandler)


